<ng-template #ddTemplateTypeKindOptions>
  <mat-option *ngFor="let option of templateTypeOptions" [value]="option.value"
    [disabled]="isDdCustomTemplateTypeDisabled(option.value)">
    <span class="dd-template-type-option">
      <span>{{ option.label }}</span>
      <mat-icon *ngIf="isDdCustomTemplateTypeDisabled(option.value)"
        class="dd-template-type-option__lock">lock</mat-icon>
    </span>
  </mat-option>
</ng-template>

<ng-container *ngIf="(shouldDisplayNoAccessPanel() | async) && isAccessCheckRequired">
  <mat-card fxFlex class="no-padding">
    <mat-card-content fxFlex fxLayout="row" fxLayoutAlign="start stretch">
      <wai-no-access-panel fxFlex fxLayout="column" fxLayoutAlign="center center"></wai-no-access-panel>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-container *ngIf="(accessDeniedReason$ | async) as accessDeniedReason">
  <mat-card fxFlex class="no-padding">
    <mat-card-content fxFlex fxLayout="row" fxLayoutAlign="start stretch">
      <wai-no-access-panel
        *ngIf="accessDeniedReason === 'blocked'"
        fxFlex fxLayout="column" fxLayoutAlign="center center"
        messageKey="INTL_DATAROOM_ACCESS_BLOCKED_MESSAGE"
      ></wai-no-access-panel>
      <wai-no-access-panel
        *ngIf="accessDeniedReason === 'forbidden'"
        fxFlex fxLayout="column" fxLayoutAlign="center center"
        messageKey="INTL_DATAROOM_ACCESS_RESTRICTED_MESSAGE"
      ></wai-no-access-panel>
      <wai-no-access-panel
        *ngIf="accessDeniedReason === 'nda_required'"
        fxFlex fxLayout="column" fxLayoutAlign="center center"
        messageKey="INTL_DATAROOM_NDA_REQUIRED_MESSAGE"
      ></wai-no-access-panel>
      <div *ngIf="accessDeniedReason === 'issuer_not_onboarded'" fxFlex fxLayout="column" fxLayoutAlign="center center">
        <p><mat-icon class="medium">info</mat-icon></p>
        <p class="align-center">{{ 'INTL_DATAROOM_ISSUER_NOT_ONBOARDED_MESSAGE' | translate }}</p>
        <button mat-stroked-button (click)="openCreateFundDialog()">
          {{ 'INTL_INVITE' | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-container *ngIf="((shouldDisplayNoAccessPanel() | async) === false || !isAccessCheckRequired) && !(accessDeniedReason$ | async)">
  <div class="container">
    <div class="mat-toolbar" fxLayout fxLayoutAlign="space-between center" fxLayoutGap="16px">
      <div class="mat-caption flex items-center justify-between toolbar-content">
        <div class="toolbar-heading">
          <wai-breadcrumbs></wai-breadcrumbs>
        </div>
        <div *ngIf="isUploadingVectorStore || isScoringInProgress || isDefaultTemplateScoreRecalculationInProgress || showFailedMessage" class="toolbar-status">
          <div *ngIf="isUploadingVectorStore || isScoringInProgress || isDefaultTemplateScoreRecalculationInProgress" class="toolbar-alert" aria-live="polite">
            <span class="toolbar-alert__dot toolbar-alert__dot--blinking"></span>
            <span class="toolbar-alert__text">Documents are being analyzed.</span>
          </div>
          <div *ngIf="showFailedMessage" class="toolbar-alert toolbar-alert--error" aria-live="polite">
            <span class="toolbar-alert__dot toolbar-alert__dot--blinking"></span>
            <span class="toolbar-alert__text">{{ failedMesssage }}</span>
          </div>
        </div>
        <!-- Left: Search & Actions -->
        <div class="flex items-center gap-2 toolbar-actions">
          <div class="toolbar-search">
            <wai-form-input [control]="search" appearance="outline" prefixIcon="search"></wai-form-input>
          </div>

          <div class="toolbar-primary-actions">
            <ng-container slot="actions" *ngIf="!isReadOnly || canEditToolbarActionsInFundDdqContext">
              <button mat-icon-button [matTooltip]="'INTL_PRODUCT_DATAROOM_ACTION_NEW_FOLDER' | translate"
                (click)="openCreateFolderDialog()" [disabled]="shouldDisableToolbarActions">
                <mat-icon>create_new_folder</mat-icon>
              </button>
              <!-- || disableUpload -->
              <span *ngIf="!selection.hasValue()" [matTooltip]="getUploadTooltip()">
                <button mat-button (click)="upload()" [disabled]="isTemplateSelectionRequiredForUpload()">
                  <mat-icon>publish</mat-icon>
                  <span>
                    {{ 'INTL_UPLOAD' | translate }}
                  </span>
                </button>
              </span>
              <button *ngIf="(isDueDiligenceEnabled$ | async) !== false" mat-icon-button color="primary"
                class="invite-person-button" [matTooltip]="'INTL_INVITE' | translate" (click)="openCreateFundDialog()"
                [disabled]="isReadOnly || shouldDisableToolbarActions">
                <mat-icon>person_add</mat-icon>
              </button>
              <button *ngIf="isBulkDownloadEnabled()" mat-button color="secondary" (click)="bulkDownload()">
                <mat-icon>download</mat-icon>
                <span>{{ 'INTL_DOWNLOAD' | translate }}</span>
              </button>
              <mat-spinner *ngIf="(loading | async) === true" diameter="21"></mat-spinner>
            </ng-container>
          </div>
        </div>

        <!-- Dataroom coverage Score Progress -->
        <!-- <div class="flex flex-col items-center justify-center ml-4 text-center">
          <div class="relative w-8 h-8">
            <svg class="w-8 h-8 transform -rotate-90" viewBox="0 0 48 48">
              <circle cx="24" cy="24" r="20" class="text-neutral-200" stroke-width="4" fill="transparent"
                stroke="currentColor" />
              <circle cx="24" cy="24" r="20" class="text-success-600" stroke-width="4" fill="transparent"
                [attr.stroke-dasharray]="circumference"
                [attr.stroke-dashoffset]="circumference - (circumference * totalScoreslevel / 100)"
                stroke-linecap="round" stroke="currentColor" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center text-[8px] font-medium text-neutral-900">
              {{ totalScoreslevel || 0 }}%
            </div>
          </div>
          <span class="score-badge mt-2" [ngClass]="{
                    'score-low': totalScores === 'Low',
                    'score-medium': totalScores === 'Medium',
                    'score-high': totalScores === 'High'
                  }">
            {{ totalScores }}
          </span>
        </div> -->

        <!-- <div *
          class="flex flex-col items-center justify-center ml-4 text-center">
          <span class="score-badge" [matTooltip]="'Dataroom coverage score'">
            Not Available
          </span>
        </div> -->

        <!-- <div class="mat-caption">
          <wai-form-input [control]="search" appearance="outline" prefixIcon="search"></wai-form-input>
          <ng-container slot="actions" *ngIf="!capabilities.isReadOnly">
            <button mat-icon-button [matTooltip]="'INTL_PRODUCT_DATAROOM_ACTION_NEW_FOLDER' | translate"
              (click)="openCreateFolderDialog()">
              <mat-icon>create_new_folder</mat-icon>
            </button>
            <button mat-button *ngIf="!selection.hasValue()" (click)="upload()">
              <mat-icon>publish</mat-icon>
              <span>
                {{ 'INTL_UPLOAD' | translate }}
              </span>
            </button>
            <button *ngIf="isBulkDownloadEnabled()" mat-button color="secondary" (click)="bulkDownload()">
              <mat-icon>download</mat-icon>
              <span>{{ 'INTL_DOWNLOAD' | translate }}</span>
            </button>
            <mat-spinner *ngIf="(loading | async) === true" diameter="21"></mat-spinner>
          </ng-container>
        </div> -->
      </div>

      <div *ngIf="canShowDueDiligence && productuid" class="dd-top-row my-2">
        <div *ngIf="getDisplayedSelectedFundName()" class="tags fund-name-tags dd-top-row__left">
          <span class="fund-name-label">Selected Fund Name</span>
          <span class="tag-warning" [matTooltip]="getDisplayedSelectedFundName()">
            {{ getDisplayedSelectedFundName() }}
          </span>
        </div>

        <div class="dd-top-row__right">
          <div class="dd-launch-inline">
            <div class="dd-template-group">
              <div class="dd-template-summary-bar">
                <div class="dd-template-summary-bar__content">
                  <div class="dd-template-summary-bar__tabs">
                    <button
                      type="button"
                      class="dd-template-summary-bar__tab"
                      [class.dd-template-summary-bar__tab--active]="isTemplateTabActive('DDQ')"
                      (click)="selectTemplateTab('DDQ')">
                      Due Diligence
                    </button>
                    <button
                      *ngIf="shouldShowImTemplateSummary()"
                      type="button"
                      class="dd-template-summary-bar__tab"
                      [class.dd-template-summary-bar__tab--active]="isTemplateTabActive('IM')"
                      (click)="selectTemplateTab('IM')">
                      Investment Memorandum
                    </button>
                  </div>

                  <div class="dd-template-summary-bar__topline">
                    <span class="dd-template-summary-bar__meta-label">Template Type:</span>
                    <span class="dd-template-summary-bar__meta-value">{{ getActiveTemplateTypeLabel() }}</span>
                    <span class="dd-template-summary-bar__separator">|</span>
                    <span class="dd-template-summary-bar__meta-label">Template Name:</span>
                    <span class="dd-template-summary-bar__meta-value">{{ getActiveTemplateNameLabel() }}</span>
                  </div>

                  <div class="dd-template-summary-bar__bottomline">
                    <div class="dd-template-summary-bar__edit-wrap" *ngIf="hasActiveTemplateSelection(); else addTemplateMessage">
                      <span class="dd-template-summary-bar__edit-label">Edit Default Template Asset Matching</span>
                      <button mat-icon-button type="button" class="dd-template-summary-bar__edit"
                        (click)="openActiveTemplateAssetMatchingModal()" aria-label="Edit default template asset matching">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                    <ng-template #addTemplateMessage>
                      <div class="dd-template-summary-bar__edit-wrap dd-template-summary-bar__edit-wrap--message">
                        <span class="dd-template-summary-bar__edit-label">Add Default Template Asset Matching</span>
                        <button mat-icon-button type="button" class="dd-template-summary-bar__edit"
                          (click)="openActiveTemplateAssetMatchingModal()" aria-label="Add default template asset matching">
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <div class="dd-launch-button-wrap">
              <span [matTooltip]="getLaunchTooltip()">
                <button [class.disabled-grey-state]="isLaunchDisabled()" [disabled]="isLaunchDisabled()"
                  style="width: 50px; height: 50px;" type="button" (click)="startDueDiligenceFlow();"
                  [matTooltip]="getLaunchTooltip()"
                  class="dd-btn-primary px-4 py-2 rounded-md shadow-sm transition duration-300 ease-in-out">
                  <mat-icon class="mt-1">rocket_launch</mat-icon>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- NO DOCUMENTS UPLOADED -->
      <div *ngIf="canShowDueDiligence && canCheckScore() && !isDataHasFile()"
        class="p-4 my-2 bg-white text-yellow-800 text-sm rounded-md message-box-tags">
        <p style="margin: 0px" class="m-0 p-0">
          Please upload documents related to
          <strong *ngFor="let document of documents; let i = index" [ngClass]="{
          'low-score': document.category_wt_level === 'Low',
          'medium-score': document.category_wt_level === 'Medium',
          'high-score': document.category_wt_level === 'High'
        }">
            {{ document.data_category }}<span *ngIf="i < documents.length - 1">, </span>
          </strong>
          to get started and improve your coverage.
        </p>
      </div>
      <div *ngIf="showProgressBar"
        class="p-4 my-2 bg-white text-yellow-800 text-sm rounded-md message-box-tags message-box-tags--progress">
        <p class="m-0 p-0 mb-2" style="margin: 0; margin-bottom: 5px;">
          We’re analyzing your documents. Your coverage score will be updated shortly.
        </p>

        <div class="progress-wrapper">
          <div class="progress-container" style="
              position: relative;
              width: 100%;
              height: 18px;
              background-color: #fde68a;
              border-radius: 9px;
              overflow: hidden;
            ">
            <div class="progress-bar" style="
                height: 100%;
                background-color: #f59e0b;
                border-radius: 9px;
                transition: width 0.4s ease-in-out;
              " [style.width.%]="progressValue"></div>

            <!-- Center text inside bar -->
            <span style="
                position: absolute;
                inset: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                font-weight: 600;
                color: #ffffff;
                pointer-events: none;
              ">
              {{ progressValue }}%
            </span>
          </div>
        </div>



      </div>


      <!-- DOCUMENTS UPLOADED & NO MISSING CATEGORIES -->
      <div *ngIf="
        canShowDueDiligence &&
        canCheckScore() &&
        isDataHasFile() &&
        totalScores &&
        categoryNamesForMissingDoc?.length !== 0
      "
        class="p-4 my-2 bg-white text-yellow-800 flex gap-4 text-sm rounded-md message-box-tags message-box-tags--score">

        <div class="flex flex-col items-center justify-center ml-4 text-center">
          <div class="relative w-10 h-10">
            <svg class="w-10 h-10 transform -rotate-90" viewBox="0 0 48 48">
              <circle cx="24" cy="24" r="20" class="text-neutral-200" stroke-width="5" fill="transparent"
                stroke="currentColor" />
              <circle cx="24" cy="24" r="20" class="text-success-600" stroke-width="5" fill="transparent"
                [attr.stroke-dasharray]="circumference"
                [attr.stroke-dashoffset]="circumference - (circumference * totalScoreslevel / 100)"
                stroke-linecap="round" stroke="currentColor" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center text-[11px] font-medium text-neutral-900">
              {{ totalScoreslevel || 0 }}%
            </div>
          </div>
          <span class="score-badge mt-2" [ngClass]="{
                    'score-low': totalScores === 'Low',
                    'score-medium': totalScores === 'Medium',
                    'score-high': totalScores === 'High'
                  }">
            {{ totalScores }}
          </span>
        </div>

        <p *ngIf="totalScores === 'Low'" style="margin: 0px" class="m-0 p-0">
          <b class="low-score">Mandatory documents are missing.</b> <br />
          Please upload the required documents
          <strong>{{ categoryNamesForMissingDoc.join(', ') }}</strong> to proceed with Due Diligence.
        </p>

        <p *ngIf="totalScores === 'Medium'" style="margin: 0px" class="m-0 p-0">
          <b class="low-score">Mandatory documents are missing.</b> <br />
          Please upload the remaining required documents
          <strong>{{ categoryNamesForMissingDoc.join(', ') }}</strong> to proceed with Due Diligence.
        </p>

        <p *ngIf="totalScores === 'High'" style="margin: 0px" class="m-0 p-0">
          <b class="low-score">Mandatory documents are missing.</b> <br />
          Please upload the remaining required documents
          <strong>{{ categoryNamesForMissingDoc.join(', ') }}</strong> to proceed with Due Diligence.
        </p>

      </div>

      <div *ngIf="false && canShowDueDiligence && productuid" class="dd-top-row my-2">
        <div *ngIf="getDisplayedSelectedFundName()" class="tags fund-name-tags dd-top-row__left">
          <span class="fund-name-label">Selected Fund Name</span>
          <span class="tag-warning" [matTooltip]="getDisplayedSelectedFundName()">
            {{ getDisplayedSelectedFundName() }}
          </span>
        </div>

        <div class="dd-top-row__right">
          <div class="dd-launch-inline">
            <div class="dd-template-group">
              <div class="mat-caption dd-launch-title"
                [class.dd-launch-title--required]="isTemplateSelectionRequiredForLaunch()">
                Select the Template before Uploading Documents
              </div>

              <div *ngIf="false" class="dd-template-controls">
                <mat-form-field appearance="outline" class="template-select-field">
                  <mat-select [formControl]="templateTypeControl" placeholder="Template type"
                    (selectionChange)="onTemplateTypeChanged($event.value)">
                    <!-- <mat-option [value]="null">None</mat-option> -->
                    <mat-option *ngFor="let option of templateTypeOptions" [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="template-select-field">
                  <mat-select [formControl]="templateNameControl" placeholder="Template name"
                    [disabled]="!templateTypeControl.value || isTemplateOptionsLoading"
                    (selectionChange)="onTemplateNameChanged($event.value)">
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngIf="isTemplateOptionsLoading" [disabled]="true">Loading…</mat-option>
                    <mat-option
                      *ngIf="!isTemplateOptionsLoading && templateTypeControl.value && templateNameOptions.length === 0"
                      [disabled]="true">
                      No templates found
                    </mat-option>
                    <mat-option *ngFor="let option of templateNameOptions" [value]="option">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="dd-launch-button-wrap">

              <!-- Tooltip must be on a non-disabled element -->
              <span [matTooltip]="getLaunchTooltip()">
                <button [class.disabled-grey-state]="
                    isAdvisorUser ||
                    isLpFreeAccess ||
                    isTemplateSelectionRequiredForLaunch() ||
                    isUploadingVectorStore ||
                    isProcessing ||
                    hasInProgressDdRun ||
                    hasInProgressImRun
                  " [disabled]="
                    isAdvisorUser ||
                    isLpFreeAccess ||
                    isTemplateSelectionRequiredForLaunch() ||
                    isUploadingVectorStore ||
                    isProcessing ||
                    hasInProgressDdRun ||
                    hasInProgressImRun
                  " style="width: 50px; height: 50px;" type="button" (click)="startDueDiligenceFlow();"
                  [matTooltip]="getLaunchTooltip()"
                  class="dd-btn-primary px-4 py-2 rounded-md shadow-sm transition duration-300 ease-in-out">
                  <mat-icon class="mt-1">rocket_launch</mat-icon>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- DOCUMENTS UPLOADED & MISSING CATEGORIES -->
      <div *ngIf="
        canShowDueDiligence &&
        canCheckScore() &&
        isDataHasFile() &&
        (totalScores || isLpFreeAccess) &&
        categoryNamesForMissingDoc?.length === 0
      "
        class="py-3 my-2 bg-white text-yellow-800 flex gap-4 text-sm rounded-md message-box-tags message-box-tags--score">

        <div class="flex flex-col items-center justify-center ml-4 text-center">
          <div class="relative w-10 h-10">
            <svg class="w-10 h-10 transform -rotate-90" viewBox="0 0 48 48">
              <circle cx="24" cy="24" r="20" class="text-neutral-200" stroke-width="5" fill="transparent"
                stroke="currentColor" />
              <circle cx="24" cy="24" r="20" class="text-success-600" stroke-width="5" fill="transparent"
                [attr.stroke-dasharray]="circumference"
                [attr.stroke-dashoffset]="circumference - (circumference * totalScoreslevel / 100)"
                stroke-linecap="round" stroke="currentColor" />
            </svg>
            <div class="absolute inset-0 flex items-center justify-center text-[11px] font-medium text-neutral-900">
              {{ totalScoreslevel || 0 }}%
            </div>
          </div>
          <span class="score-badge mt-2" [ngClass]="{
                    'score-low': totalScores === 'Low',
                    'score-medium': totalScores === 'Medium',
                    'score-high': totalScores === 'High'
                  }">
            {{ totalScores }}
          </span>
        </div>

        <!-- LOW SCORE GUIDING -->
        <p style="margin: 0px" *ngIf="totalScores === 'Low'" class="m-0 p-0">
          <b>Your Dataroom coverage is Low.</b> <br />
          Additionally, the following categories have limited Dataroom coverage:
          <strong *ngFor="let document of documents; let i = index" [ngClass]="{
              'low-score': document.category_wt_level === 'Low',
              'medium-score': document.category_wt_level === 'Medium',
              'high-score': document.category_wt_level === 'High'
            }">
            {{ document.data_category }}<span *ngIf="i < documents.length - 1">, </span>
          </strong>. Uploading documents related to these categories will significantly improve your coverage score and
          analysis
          depth.
        </p>

        <!-- MEDIUM SCORE GUIDING -->
        <p style="margin: 0px" *ngIf="totalScores === 'Medium'" class="m-0 p-0">
          <b>Your current Dataroom coverage score is Medium.</b> <br />
          You can further improve your score by uploading additional documents from the following categories:
          <strong *ngFor="let document of documents; let i = index" [ngClass]="{
              'low-score': document.category_wt_level === 'Low',
              'medium-score': document.category_wt_level === 'Medium',
              'high-score': document.category_wt_level === 'High'
            }">
            {{ document.data_category }}<span *ngIf="i < documents.length - 1">, </span>
          </strong>.
        </p>


        <p style="margin: 0px" *ngIf="totalScores === 'High'" class="m-0 p-0">
          <b>Your Dataroom coverage score is High.</b> <br />
          You may optionally upload additional documents to cover
          <strong *ngFor="let document of documents; let i = index" [ngClass]="{
              'low-score': document.category_wt_level === 'Low',
              'medium-score': document.category_wt_level === 'Medium',
              'high-score': document.category_wt_level === 'High'
            }">
            {{ document.data_category }}<span *ngIf="i < documents.length - 1">, </span>
          </strong> or go ahead to launch due diligence
        </p>

        <div *ngIf="false && (totalScores || isLpFreeAccess) && canShowDueDiligence && productuid"
          class="dd-launch-area">
          <div class="mat-caption dd-launch-hint"
            [class.dd-launch-hint--required]="isTemplateSelectionRequiredForLaunch()">
            Select the Template before Uploading Documents
          </div>

          <div class="dd-launch-controls-row">
            <div *ngIf="false" class="dd-template-controls">
              <mat-form-field appearance="outline" class="template-select-field">
                <mat-select [formControl]="templateTypeControl" (selectionChange)="onTemplateTypeChanged($event.value)">
                  <mat-select-trigger>
                    <span class="template-select-display"
                      [class.template-select-display--placeholder]="!templateTypeControl.value">
                      {{
                      templateTypeControl.value === 'standard'
                      ? 'Standard'
                      : templateTypeControl.value === 'custom'
                      ? 'Custom'
                      : 'Template type'
                      }}
                    </span>
                  </mat-select-trigger>
                  <!-- <mat-option [value]="null">None</mat-option> -->
                  <mat-option *ngFor="let option of templateTypeOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <button mat-icon-button matSuffix type="button" class="template-clear-btn"
                  *ngIf="templateTypeControl.value" (click)="clearTemplateType($event)"
                  [attr.aria-label]="'Clear template type'">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline" class="template-select-field">
                <mat-select [formControl]="templateNameControl"
                  [disabled]="!templateTypeControl.value || isTemplateOptionsLoading"
                  (selectionChange)="onTemplateNameChanged($event.value)">
                  <mat-select-trigger>
                    <span class="template-select-display"
                      [class.template-select-display--placeholder]="!templateNameControl.value">
                      {{ templateNameControl.value?.name || 'Template name' }}
                    </span>
                  </mat-select-trigger>
                  <!-- <mat-option [value]="null">None</mat-option> -->
                  <mat-option *ngIf="isTemplateOptionsLoading" [disabled]="true">Loading…</mat-option>
                  <mat-option
                    *ngIf="!isTemplateOptionsLoading && templateTypeControl.value && templateNameOptions.length === 0"
                    [disabled]="true">
                    No templates found
                  </mat-option>
                  <mat-option *ngFor="let option of templateNameOptions" [value]="option">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
                <button mat-icon-button matSuffix type="button" class="template-clear-btn"
                  *ngIf="templateNameControl.value" (click)="clearTemplateName($event)"
                  [attr.aria-label]="'Clear template name'">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Tooltip must be on a non-disabled element -->
            <span [matTooltip]="getLaunchTooltip()">
              <button [ngClass]="{ 'ddq-upgrade-blocked': isLaunchUpgradeBlocked() }"
                *ngIf="totalScores || isLpFreeAccess" [class.disabled-grey-state]="
                  isAdvisorUser ||
                  isLpFreeAccess ||
                  isTemplateSelectionRequiredForLaunch() ||
                  isUploadingVectorStore ||
                  isProcessing ||
                  hasInProgressDdRun ||
                  hasInProgressImRun
                " [disabled]="
                  isAdvisorUser ||
                  isLpFreeAccess ||
                  isTemplateSelectionRequiredForLaunch() ||
                  isUploadingVectorStore ||
                  isProcessing ||
                  hasInProgressDdRun ||
                  hasInProgressImRun
                " style="width: 50px; height: 50px;" type="button" (click)="startDueDiligenceFlow();"
                [matTooltip]="getLaunchTooltip()"
                class="dd-btn-primary px-4 py-2 rounded-md shadow-sm transition duration-300 ease-in-out">
                <mat-icon class="mt-1">rocket_launch</mat-icon>
                <mat-icon *ngIf="isLaunchUpgradeBlocked()" class="hover-lock-icon">lock</mat-icon>
              </button>
            </span>
          </div>
        </div>
      </div>

      <div class="py-2 px-3 bg-white text-yellow-800 text-sm rounded-md recommended-documents-panel">
        <h3 class="mb-1">Recommended Documents</h3>
        <p class="m-0 tags recommended-tags" style="margin: 0">
          <ng-container *ngFor="let category of recommended_category_list">
            <span class="tag-warning">
              {{category}}
            </span>
          </ng-container>
        </p>
      </div>
      <ng-container *ngIf="{ table: (tableLoading$ | async) } as loadState">
        <div *ngIf="loadState.table"
          class="w-full flex justify-center items-center py-10 bg-white rounded-md mat-elevation-z1">
          <div class="flex items-center gap-2">
            <i class="pi pi-spin pi-spinner text-primary-600" style="font-size: 1.5rem;"></i>
            <span class="text-primary-600 font-medium">Loading data...</span>
          </div>
        </div>

        <!-- Keep table in DOM while loading so MatSort ViewChild stays available -->
        <div class="file-list-wrapper" [hidden]="loadState.table">
        <mat-table *ngIf="dataSource" [dataSource]="dataSource" matSort class="file-list mat-elevation-z1">
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox *ngIf="hasFile | async" [disabled]="capabilities.isReadOnly"
                (change)="$event ? toggleMaster() : null" [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </mat-header-cell>

            <mat-cell *matCellDef="let row">
              <mat-checkbox *ngIf="isFile(row)" [disabled]="capabilities.isReadOnly" (change)="toggleSelect(row)"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="category">
            <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>
              Category
            </mat-header-cell>
            <mat-cell fxFlex *matCellDef="let element">
              <ng-container *ngIf="element.type === 'file'; else folderCategory">
                <span *ngIf="element.category; else categoryLoader">{{ element.category }}</span>
                <ng-template #categoryLoader>
                  <mat-spinner diameter="16"></mat-spinner>
                </ng-template>
              </ng-container>
              <ng-template #folderCategory>
                <span>-</span>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell fxFlex="25" *matHeaderCellDef mat-sort-header>
              {{ 'INTL_NAME' | translate }}
            </mat-header-cell>
            <mat-cell fxFlex="25" *matCellDef="let element">
              <div *ngIf="element.type === 'file'; else folder" class="file-name mat-subtitle-2"
                [title]="getNodeDisplayName(element)">
                <fa-icon [icon]="getIcon(element?.file?.contentType)" class="icon small"
                  [ngClass]="getIconColor(element?.file?.contentType)"></fa-icon>
                <strong class="file-name-text">{{ truncateFileName(getNodeDisplayName(element)) }}</strong>
                <mat-icon *ngIf="element.displayInProductSummary"
                  matTooltip="{{ 'INTL_INCLUDED_IN_SUMMARY' | translate }}" class="included-icon" color="primary">
                  check_circle
                </mat-icon>

                <mat-icon *ngIf="element.keyMetric" matTooltip="{{ 'INTL_KEY_METRICS' | translate }}"
                  class="included-icon" color="accent">
                  insights
                </mat-icon>

                <mat-icon *ngIf="element.regulatoryRequiredDocument"
                  matTooltip="{{ 'INTL_REGULATORY_REQUIRED_DOCUMENT' | translate }}" class="included-icon" color="warn">
                  gavel
                </mat-icon>
              </div>
              <ng-template #folder>
                <div class="file-name" [title]="element.name">
                  <a [routerLink]="['./' + element.id]" [queryParams]="activatedRoute.snapshot.queryParams"
                    queryParamsHandling="merge" class="mat-subtitle-2">
                    <mat-icon class="icon small" color="primary">folder</mat-icon>
                    <strong class="file-name-text">{{ dataroomFolder[element.name] || element.name }}</strong>
                  </a>
                </div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container *ngIf="(isCompactView$ | async) === false" matColumnDef="modifiedAt">
            <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>{{ 'INTL_PRODUCT_DATAROOM_LABEL_MODIFIED_AT' |
              translate }}
            </mat-header-cell>
            <mat-cell fxFlex *matCellDef="let element">
              {{ element.modifiedAt | waiDate }}
            </mat-cell>
          </ng-container>

          <ng-container *ngIf="(isCompactView$ | async) === false" matColumnDef="file.size">
            <mat-header-cell class="file-size-header-cell" *matHeaderCellDef mat-sort-header>
              <span class="file-size-header-text">{{ 'INTL_PRODUCT_DATAROOM_LABEL_FILE_SIZE' | translate }}</span>
            </mat-header-cell>
            <mat-cell class="file-size-value-cell" *matCellDef="let element">
              <span class="file-size-value-text">{{ element.file?.fileSize | fileSize }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="menu">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div class="menu-actions">
                <!-- Always show preview button -->
                <button class="menu-action-button" mat-icon-button (click)="preview(element)"
                  [matTooltip]="getViewTooltip(element)">
                  <mat-icon color="secondary"
                    *ngIf="element.type === 'file' && hasPreview(element)">visibility</mat-icon>
                  <mat-icon color="secondary"
                    *ngIf="element.type === 'file' && !hasPreview(element)">visibility_off</mat-icon>
                </button>

                <!-- Always show download button -->
                <button class="menu-action-button" mat-icon-button *ngIf="fileHasValue(element) && element.file"
                  (click)="download(element)">
                  <mat-icon color="secondary">get_app</mat-icon>
                </button>

                <ng-container *ngIf="(isCompactView$ | async) === false">
                  <!-- Upload button - only for write access -->
                  <button class="menu-action-button" mat-icon-button
                    *ngIf="isFile(element) && (!fileHasValue(element) || !element.file) && !capabilities.isReadOnly"
                    (click)="openUpdateDialog(element)">
                    <mat-icon color="secondary">publish</mat-icon>
                  </button>

                  <!-- Product dataroom specific buttons -->
                  <button class="menu-action-button" mat-icon-button
                    *ngIf="showIncludeExcludeSummary(element) && !isReadOnly"
                    (click)="openSummaryStatusChangeDialog(element)" matTooltip="{{
                  element.displayInProductSummary
                    ? ('INTL_PRODUCT_DATAROOM_ACTION_EXCLUDE_FROM_SUMMARY' | translate)
                    : ('INTL_PRODUCT_DATAROOM_ACTION_INCLUDE_TO_SUMMARY' | translate)
                }}">
                    <mat-icon>{{ element.displayInProductSummary ? 'remove' : 'add' }}</mat-icon>
                  </button>

                  <button class="menu-action-indicator" mat-menu-button
                    *ngIf="element.type === 'file' && element?.file?.name && canCheckScore() && canShowDueDiligence"
                    [matTooltip]="element.aiScore === 'Invalid' ? 'Invalid Document Type' : element.isCalculating ? 'Coverage Score' : 'Evaluating Coverage Score'"
                    matTooltipPosition="above" aria-label="Coverage score">
                    <span *ngIf="element.isCalculating" class="score-badge" [ngClass]="{
                    'score-low': element.aiScore === 'Low' || element.aiScore === 'Invalid',
                    'score-medium': element.aiScore === 'Medium',
                    'score-high': element.aiScore === 'High'
                  }">
                      {{ element.aiScore }}
                    </span>
                    <div *ngIf="!element.isCalculating" class="flex items-center gap-2">
                      <mat-spinner diameter="16"></mat-spinner>
                    </div>
                  </button>

                  <button class="menu-action-indicator" mat-menu-button
                    *ngIf="element.type === 'file' && !(element.type === 'file' && !element?.file?.name) && canCheckScore() && canShowDueDiligence && !!element.status"
                    class="button-file" (click)="onStatusIndicatorClick(element)"
                    [disabled]="isStatusDisable(element?.status)" [matTooltip]="getStatusTooltip(element?.status)">
                    <mat-icon *ngIf="element.status === 'loading'" color="primary"
                      class="processing-icon">hourglass_empty</mat-icon>
                    <mat-icon *ngIf="element?.status === 'failed' || element?.status === 'notSupported'"
                      [class]="element?.status === 'failed' ? 'failed-status-icon' : 'notSupported-status-icon'">cancel</mat-icon>
                    <mat-icon *ngIf="element?.status === 'completed'" color="accent">check_circle</mat-icon>
                  </button>

                  <button class="menu-action-button" mat-icon-button
                    *ngIf="showKeyMetricsButton(element) && !isReadOnly"
                    (click)="openKeyMetricsStatusChangeDialog(element)" matTooltip="{{
                  element.keyMetric
                    ? ('INTL_UNMARK_AS_KEY_METRICS' | translate)
                    : ('INTL_MARK_AS_KEY_METRICS' | translate)
                }}">
                    <mat-icon [color]="element.keyMetric ? 'warn' : 'default'">insights</mat-icon>
                  </button>

                  <button class="menu-action-button" mat-icon-button
                    *ngIf="showIncludeExcludeSummary(element) && !isReadOnly"
                    (click)="openRegulatoryDocumentStatusChangeDialog(element)" matTooltip="{{
                  element.regulatoryRequiredDocument
                    ? ('INTL_UNMARK_AS_REGULATORY' | translate)
                    : ('INTL_MARK_AS_REGULATORY' | translate)
                }}">
                    <mat-icon [color]="element.regulatoryRequiredDocument ? 'warn' : 'default'">gavel</mat-icon>
                  </button>
                </ng-container>

                <span *ngIf="isCompactView$ | async" class="tooltip" (click)="showInfo($event, element)">
                  <mat-icon color="accent">info</mat-icon>
                </span>

                <button class="menu-action-button" mat-icon-button [matMenuTriggerFor]="menu"
                  *ngIf="showMenuButton(element) && !isReadOnly">
                  <mat-icon color="secondary">more_vert</mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                  <button mat-menu-item *ngIf="showUpdateButton(element)" (click)="openUpdateDialog(element)">
                    <mat-icon>publish</mat-icon>
                    <span>{{ 'INTL_UPDATE' | translate }}</span>
                  </button>
                  <button mat-menu-item *ngIf="showRenameButton(element)" (click)="openRenameDialog(element)">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'INTL_PRODUCT_DATAROOM_ACTION_RENAME' | translate }}</span>
                  </button>
                  <button mat-menu-item *ngIf="showMoveButton(element)" (click)="openMoveDialog(element)">
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                    <span>{{ 'INTL_PRODUCT_DATAROOM_ACTION_MOVE_TO' | translate }}</span>
                  </button>
                  <button mat-menu-item *ngIf="showIncludeExcludeSummary(element) && !isReadOnly"
                    (click)="openSummaryStatusChangeDialog(element)">
                    <mat-icon>{{ element.displayInProductSummary ? 'remove' : 'add' }}</mat-icon>
                    <span>{{
                      element.displayInProductSummary
                      ? ('INTL_PRODUCT_DATAROOM_ACTION_EXCLUDE_FROM_SUMMARY' | translate)
                      : ('INTL_PRODUCT_DATAROOM_ACTION_INCLUDE_TO_SUMMARY' | translate)
                      }}</span>
                  </button>
                  <button mat-menu-item *ngIf="showKeyMetricsButton(element) && !isReadOnly"
                    (click)="openKeyMetricsStatusChangeDialog(element)">
                    <mat-icon>insights</mat-icon>
                    <span>{{
                      element.keyMetric
                      ? ('INTL_UNMARK_AS_KEY_METRICS' | translate)
                      : ('INTL_MARK_AS_KEY_METRICS' | translate)
                      }}</span>
                  </button>
                  <button mat-menu-item *ngIf="showIncludeExcludeSummary(element) && !isReadOnly"
                    (click)="openRegulatoryDocumentStatusChangeDialog(element)">
                    <mat-icon>gavel</mat-icon>
                    <span>{{
                      element.regulatoryRequiredDocument
                      ? ('INTL_UNMARK_AS_REGULATORY' | translate)
                      : ('INTL_MARK_AS_REGULATORY' | translate)
                      }}</span>
                  </button>
                  <button mat-menu-item *ngIf="element.type === 'file' && productuid"
                    (click)="recalculateScore(element)">
                    <mat-icon>refresh</mat-icon>
                    <span>Recalculate Score</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button [disabled]="isDeleteDisabled()" mat-menu-item *ngIf="showDeleteButton(element)"
                    (click)="openDeleteConfirmationDialog(element)">
                    <mat-icon>delete</mat-icon>
                    <span>{{ 'INTL_DELETE' | translate }}</span>
                  </button>
                </mat-menu>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" (click)="markSelected(row)"
            (dblclick)="handleDoubleClick(row)" [ngClass]="{ selected: isRowSelected(row) }"></mat-row>
        </mat-table>
      </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<!-- </mat-sidenav-container> -->

<!-- Due Diligence Modal Template -->
<ng-template #dueDiligenceModal>
  <h2 mat-dialog-title class="text-red-600 font-semibold">Missing Required Documents</h2>

  <mat-dialog-content>
    <p>The following required documents appear to be missing:</p>
    <ul>
      <li *ngFor="let category of categoryNamesForMissingDoc">{{ category }}</li>
    </ul>
    <p>Do you still want to move further?</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="warn" type="button" (click)="continueFromMissingDocuments()">
      Continue Anyway
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #imDefaultTemplateAssetMatchingModal>
  <div class="default-template-edit-modal">
    <div class="default-template-edit-modal__header">
      <div class="default-template-edit-modal__header-content">
        <h2 class="default-template-edit-modal__title">Default Template Asset Matching</h2>
        <p class="default-template-edit-modal__subtitle">
          Edit the current template mapping details for this investment memorandum.
        </p>
      </div>
      <button type="button" class="default-template-edit-modal__close" (click)="cancelImDefaultTemplateAssetMatchingModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="default-template-edit-modal__content" *ngIf="imDefaultTemplateAssetMatchingDraft">
      <div
        class="default-template-edit-modal__helper"
        *ngIf="!isImDefaultTemplateAssetMatchingLoading && hasResolvedImDefaultTemplateOptionsInModal && showImDefaultTemplateCreateHelperInModal"
      >
        No template is available for this asset and sub-asset combination. Please create one first.
      </div>

      <div class="default-template-edit-modal__grid">
        <mat-form-field appearance="outline">
          <mat-label>Asset Class</mat-label>
          <mat-select
            [(ngModel)]="imDefaultTemplateAssetMatchingDraft.assetClassId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isImDefaultTemplateAssetMatchingLoading"
            (selectionChange)="onImDefaultTemplateAssetClassChanged($event.value)"
          >
            <mat-option *ngFor="let option of imDefaultTemplateAssetClassOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Sub Asset Class</mat-label>
          <mat-select
            [(ngModel)]="imDefaultTemplateAssetMatchingDraft.subAssetClassId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isImDefaultTemplateAssetMatchingLoading || imDefaultTemplateSubAssetClassOptions.length === 0"
            (selectionChange)="onImDefaultTemplateSubAssetClassChanged($event.value)"
          >
            <mat-option *ngFor="let option of imDefaultTemplateSubAssetClassOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select
            [(ngModel)]="imDefaultTemplateAssetMatchingDraft.type"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isImDefaultTemplateAssetMatchingLoading"
            (selectionChange)="onImDefaultTemplateTypeChanged($event.value)"
          >
            <mat-option value="standard">Standard</mat-option>
            <mat-option value="custom">Custom</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Template Name</mat-label>
          <mat-select
            [(ngModel)]="imDefaultTemplateAssetMatchingDraft.templateId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isImDefaultTemplateAssetMatchingLoading || imDefaultTemplateNameOptions.length === 0"
            (selectionChange)="onImDefaultTemplateNameChanged($event.value)"
          >
            <mat-option *ngFor="let option of imDefaultTemplateNameOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="default-template-edit-modal__actions">
      <button mat-button type="button" (click)="cancelImDefaultTemplateAssetMatchingModal()">Cancel</button>
      <button mat-flat-button color="primary" type="button" (click)="saveImDefaultTemplateAssetMatchingModal()">
        Save Changes
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #defaultTemplateAssetMatchingModal>
  <div class="default-template-edit-modal">
    <div class="default-template-edit-modal__header">
      <div class="default-template-edit-modal__header-copy">
        <h2 class="default-template-edit-modal__title">Default Template Asset Matching</h2>
        <p class="default-template-edit-modal__subtitle">
          Edit the current template mapping details for this dataroom.
        </p>
      </div>
      <button type="button" class="default-template-edit-modal__close" (click)="cancelDefaultTemplateAssetMatchingModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="default-template-edit-modal__content" *ngIf="defaultTemplateAssetMatchingDraft">
      <div
        class="default-template-edit-modal__helper"
        *ngIf="!isDefaultTemplateAssetMatchingLoading && hasResolvedDefaultTemplateOptionsInModal && showDefaultTemplateCreateHelperInModal"
      >
        No template is available for this asset and sub-asset combination. Please create one first.
      </div>

      <div class="default-template-edit-modal__grid">
        <mat-form-field appearance="outline">
          <mat-label>Asset Class</mat-label>
          <mat-select
            [(ngModel)]="defaultTemplateAssetMatchingDraft.assetClassId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isDefaultTemplateAssetMatchingLoading"
            (selectionChange)="onDefaultTemplateAssetClassChanged($event.value)"
          >
            <mat-option *ngFor="let option of defaultTemplateAssetClassOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Sub Asset Class</mat-label>
          <mat-select
            [(ngModel)]="defaultTemplateAssetMatchingDraft.subAssetClassId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isDefaultTemplateAssetMatchingLoading || defaultTemplateSubAssetClassOptions.length === 0"
            (selectionChange)="onDefaultTemplateSubAssetClassChanged($event.value)"
          >
            <mat-option *ngFor="let option of defaultTemplateSubAssetClassOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select
            [(ngModel)]="defaultTemplateAssetMatchingDraft.type"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isDefaultTemplateAssetMatchingLoading"
            (selectionChange)="onDefaultTemplateTypeChanged($event.value)"
          >
            <mat-option value="standard">Standard</mat-option>
            <mat-option value="custom">Custom</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Template Name</mat-label>
          <mat-select
            [(ngModel)]="defaultTemplateAssetMatchingDraft.templateId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isDefaultTemplateAssetMatchingLoading || defaultTemplateNameOptions.length === 0"
            (selectionChange)="onDefaultTemplateNameChanged($event.value)"
          >
            <mat-option *ngFor="let option of defaultTemplateNameOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="default-template-edit-modal__actions">
      <button mat-stroked-button type="button" (click)="cancelDefaultTemplateAssetMatchingModal()">Cancel</button>
      <button mat-raised-button color="primary" type="button" (click)="saveDefaultTemplateAssetMatchingModal()">
        Save Changes
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #fundNameModal>
  <div class="fund-name-modal">
    <div class="fund-name-modal__header">
      <div class="fund-name-modal__header-content">
        <h2 class="fund-name-modal__title">Select Fund Name</h2>
        <p class="fund-name-modal__subtitle">
          Select the fund name for this due diligence launch.
        </p>
      </div>
      <button type="button" class="fund-name-modal__close" (click)="cancelFundNameModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="fund-name-modal__content">
      <div class="fund-name-modal__status" *ngIf="isFundNameSuggestionsLoading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading fund names...</span>
      </div>

      <div class="fund-name-option-list">
        <div *ngFor="let option of fundNameOptions" class="fund-name-option"
          [class.fund-name-option--selected]="selectedFundName === option.name" (click)="selectFundName(option)">
          <div class="fund-name-option__selection">
            <input type="radio" name="dataroomDdFundName" class="fund-name-option__radio-input"
              [checked]="selectedFundName === option.name" (change)="selectFundName(option)"
              (click)="$event.stopPropagation()" />
            <span class="fund-name-option__radio"></span>
          </div>

          <div class="fund-name-option__body">
            <div *ngIf="!option.isEditing" class="fund-name-option__name"
              [matTooltip]="getFundNameSourceTooltip(option)">
              {{ option.name }}
            </div>

            <input *ngIf="option.isEditing" [(ngModel)]="option.name" (click)="$event.stopPropagation()"
              (keydown.enter)="saveFundNameEdit(option)" (blur)="saveFundNameEdit(option)"
              class="fund-name-option__input" placeholder="Enter fund name" />
          </div>

          <button type="button" class="fund-name-option__edit" [class.fund-name-option__edit--active]="option.isEditing"
            (mousedown)="handleFundNameAction(option, $event)"
            [matTooltip]="option.isEditing ? 'Save fund name' : 'Edit fund name'">
            <mat-icon>{{ option.isEditing ? 'check' : 'edit' }}</mat-icon>
          </button>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="fund-name-modal__actions">
      <button mat-stroked-button type="button" (click)="cancelFundNameModal()">Cancel</button>
      <button mat-raised-button color="primary" type="button"
        [disabled]="isFundNameSuggestionsLoading || !selectedFundName?.trim()" (click)="confirmFundNameSelection()">
        Continue
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
